import type { Language } from "./Language";
import type { LanguageCollection } from "./LanguageCollection";

export type Contraction = "no" | "partial" | "full";

export interface BrailleTranslationTableJson {
	filename: string;
	displayName: string;
	nativeName: string;
	indexName: string;
	computer: boolean;
	grade: string;
	dots: number;
	language: string;
	contraction: string;
  }
  
  export class BrailleTranslationTable {
	filename: string;
	displayName: string | undefined;
	nativeName: string | undefined;
	indexName: string | undefined;
	computer: boolean | undefined;
	grade: number | undefined;
	dots: number| undefined;
	language: Language| undefined;
	contraction: Contraction | undefined;

	constructor(
	  json: BrailleTranslationTableJson,
	  allLanguages: LanguageCollection
	) {
		this.filename = json.filename;
		this.displayName = json.displayName;
		this.nativeName = json.nativeName;
		this.indexName = json.indexName;
		this.computer = json.computer;
		this.grade = Number.parseInt(json.grade) || undefined;
		this.dots = Number.isInteger(json.dots) ? json.dots : undefined;
	 	this.language = allLanguages.get(json.language)!;

		if (json.contraction == "no" || json.contraction == "partial" || json.contraction == "full") {
			// TODO it seems as if there should be a more elegant way to write this type check,
			// and keep it in sync with the actual type definition, in TypeScript. But how?
			this.contraction = json.contraction;
		}
	}
  }
  